import { RoomMadeBy, RoomProvider } from "@onair/repositories";

export enum CoHostType {
	SYSTEM = "system",
	EMAIL = "email",
}

export enum ExtendRoomProvider {
	SYSTEM = "SYSTEM",
	ZOOM = "ZOOM",
	GOOGLE_MEET = "GOOGLE_MEET",
}

export const getLabelFromClientRoomProvider = (provider: ExtendRoomProvider): string => {
	const roomProvider = convertClientRoomProviderToServer(provider);
	return getLabelFromServerRoomProvider(roomProvider);
}

export const getLabelFromServerRoomProvider = (provider: RoomProvider): string => {
	switch (provider) {
		case RoomProvider.GOOGLE_MEET:
			return "Google Meet";
		case RoomProvider.ZOOM:
			return "Zoom";
	}
}

export const convertClientRoomProviderToServer = (
	provider: ExtendRoomProvider,
): RoomProvider => {
	switch (provider) {
		case ExtendRoomProvider.SYSTEM:
			return RoomProvider.GOOGLE_MEET;
		case ExtendRoomProvider.ZOOM:
			return RoomProvider.ZOOM;
		case ExtendRoomProvider.GOOGLE_MEET:
			return RoomProvider.GOOGLE_MEET;
	}
};

export const convertServerRoomProviderToClient = (
	provider: RoomProvider,
	roomMadeBy: RoomMadeBy,
): ExtendRoomProvider => {
	if (roomMadeBy === RoomMadeBy.SYSTEM) {
		return ExtendRoomProvider.SYSTEM;
	}

	switch (provider) {
		case RoomProvider.GOOGLE_MEET:
			return ExtendRoomProvider.GOOGLE_MEET;
		case RoomProvider.ZOOM:
			return ExtendRoomProvider.ZOOM;
	}
};
